module.exports = __webpack_public_path__ + "static/media/winner.3fa31c83.png";